import React, { useRef, useEffect, ReactNode } from "react";
import { Runtime, Inspector } from "@observablehq/runtime";
import notebook from "@hypercerts-org/observabletreemap";
import { PlasmicElement } from "@plasmicapp/host";

export interface GenericHypercertTreemapProps {
  className?: string;
  children: ReactNode;
  //backgroundImageUrl?: string;
  data: object;
}

const defaultChildren: PlasmicElement[] = [
  {
    type: "text",
    value: "Credit: Original notebook - hypercerts by category by hypercerts",
    tag: "a",
    attrs: {
      href: "https://observablehq.com/d/c857fa5c110524ee",
    },
  },
];

export function GenericHypercertTreemap(props: GenericHypercertTreemapProps) {
  const { className, children, data } = props;
  const chartRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const runtime = new Runtime();
    const main = runtime.module(notebook, (name) => {
      if (name === "chart") {
        return new Inspector(chartRef.current);
      }
    });
    main.redefine("data", data);

    // TODO: Fix backgroundImages. Leaving this inline for context later.
    // Keeping this here for now because we'd like to get background images
    // working if we can fix the rendering. The value passed into observable
    // needs to be an HTMLImageElement. So the commented code doesn't exactly
    // work yet.
    //main.redefine("zuzaluLogo400x600", backgroundImageUrl);
    return () => runtime.dispose();
  }, []);

  return (
    <div className={className}>
      <div ref={chartRef} />
      {children}
    </div>
  );
}

GenericHypercertTreemap.defaultChildren = defaultChildren;
